import { render, staticRenderFns } from "./realFreeAudition.vue?vue&type=template&id=486da15b&scoped=true&"
import script from "./realFreeAudition.ts?vue&type=script&lang=js&"
export * from "./realFreeAudition.ts?vue&type=script&lang=js&"
import style0 from "./realFreeAudition.less?vue&type=style&index=0&id=486da15b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486da15b",
  null
  
)

export default component.exports